import styled from 'styled-components';

import { BREAKPOINT } from '../constants';

export default styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 24px 24px 12px 24px;
  box-sizing: border-box;
  border-radius: 4px;
  color: #484848;
  position: relative;

  @media (min-width: ${BREAKPOINT}px) {
    margin: 12px 0;
  }

  @media (min-width: 960px) {
    border: 2px solid #DBDEE2;
  }

  @media (max-width: ${BREAKPOINT}px) {
    margin: 16px 0;
  }

  @media (max-width: 960px) {
    background-color: #FFF;
  }
`;
